import {
    LOADING_TOGGLE_ACTION,
    LOGIN_CONFIRMED_ACTION,
    LOGIN_FAILED_ACTION,
    LOGOUT_ACTION,
    SIGNUP_CONFIRMED_ACTION,
    SIGNUP_FAILED_ACTION,
} from '../actions/AuthActions';

const initialState = {
    auth: {
        email: '',
        token: '', // Updated to store token
        globalSessionId: '', // To store global session ID
        subscription: '', // To store subscription
        accesstoken: '', // To store subscription
    },
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function AuthReducer(state = initialState, action) {
    if (action.type === SIGNUP_CONFIRMED_ACTION) {
        return {
            ...state,
            auth: action.payload,
            errorMessage: '',
            successMessage: 'Signup Successfully Completed',
            showLoading: false,
        };
    }
    
    if (action.type === LOGIN_CONFIRMED_ACTION) {
        // Payload arrives in two shapes: the sign-in API response (snake_case:
        // subscription_type / access_token / global_session_id) and the
        // localStorage tokenDetails written by saveTokenInLocalStorage
        // (camelCase: subscription / accessToken / globalSessionId). Accept both,
        // otherwise plan and API token are lost on auto-login after refresh.
        return {
            ...state,
            auth: {
                email: action.payload.email, // Update email
                token: action.payload.token, // Store token
                globalSessionId: action.payload.global_session_id || action.payload.globalSessionId,
                subscription: action.payload.subscription_type || action.payload.subscription,
                accesstoken: action.payload.accessToken || action.payload.access_token,
            },
            errorMessage: '',
            successMessage: 'Login Successfully Completed',
            showLoading: false,
        };
    }

    if (action.type === LOGOUT_ACTION) {
        return {
            ...state,
            errorMessage: '',
            successMessage: '',
            auth: {
                email: '',
                token: '',
                globalSessionId: '',
                subscription: '',
                accesstoken: ''
            },
        };
    }

    if (
        action.type === SIGNUP_FAILED_ACTION ||
        action.type === LOGIN_FAILED_ACTION
    ) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    }

    if (action.type === LOADING_TOGGLE_ACTION) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }
    
    return state;
}
